// The hub's contents, kept as data so the page, the ItemList JSON-LD and the
// sitemap can't drift apart.
//
// Calculators only — things you open, fill in, and get a number back from.
// /receipts and /trips were briefly listed here and shouldn't be: a page
// called "calculators" that lists product pages undercuts what it claims to
// be, and the ItemList JSON-LD would be asserting they're the same kind of
// thing. They're linked from the prose instead, which is where "use the app
// for this one" belongs.
export type CalcEntry = {
  href: string;
  title: string;
  blurb: string;
  cta: string;
};

export const CALCULATORS: CalcEntry[] = [
  {
    href: '/airbnb-split-calculator',
    title: 'Airbnb split calculator',
    blurb:
      'This calculator works out what each spot in the Airbnb should cost, weighted by the three things that matter most. And it gives you a message you can paste straight into the group chat so you can decide who goes where before booking.',
    cta: 'Open the Airbnb calculator',
  },
  {
    href: '/rent-split-calculator',
    title: 'Rent split calculator',
    blurb:
      'Splitting rent evenly only works when the bedrooms are equal. This weights each room by size and bathroom, splits the common space evenly by headcount, and gives you a monthly figure per person to send the group before anyone signs.',
    cta: 'Open the rent calculator',
  },
];

// Guides that answer a splitting question without a tool attached. Kept
// separate so the ItemList above stays things you can open and use.
export const GUIDES: { href: string; label: string }[] = [
  {
    href: '/tips/how-to-split-an-airbnb-with-unequal-rooms',
    label: 'How to split an Airbnb when the rooms aren’t equal',
  },
  {
    href: '/support/payers-and-payees/splitting-a-bill-evenly',
    label: 'How to split a bill evenly with Tabster',
  },
  {
    href: '/support/payers-and-payees/splitting-tax-and-tip-on-a-shared-bill',
    label: 'How tax and tip are split on a shared bill',
  },
  {
    href: '/support/payers-and-payees/splitting-appetizers-or-other-shareables',
    label: 'Splitting appetizers and other shareables',
  },
  {
    href: '/support/roommates/a-running-tab-with-each-roommate',
    label: 'Splitting costs with roommates on Tabster',
  },
];
